import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { distinctUntilChanged } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from 'src/app/modules/authentication/login-pages/services/login.service';
import { BreakpointObserverService } from '../navigation/services/breakpoint-observer.service';
import packageJson from 'package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  year = new Date().getFullYear();
  showDisclaimer = false;

  lbl: string = '';
  lblDisclaimer: string = '';
  loggedIn: boolean;
  public isScreenSmall$: Observable<boolean>;
  private subscriptions: Subscription[] = [];

  publicDisclaimer: string;
  version: string;

  constructor(
    private breakpointObserverService: BreakpointObserverService,
    private labelService: LabelService,
    private authService: AuthService,
    private loginService: LoginService,
    private modalService: NgbModal
  ) {
    this.isScreenSmall$ = this.breakpointObserverService.isScreenSmall$;
    this.version = packageJson.version;
  }

  openModal(longContent) {
    this.modalService.open(longContent, { centered: true, backdrop: 'static' });
  }

  ngOnInit() {
    this.subscriptions.push(
      this.labelService.refreshPageNameInCache('general').subscribe((e) => {
        this.subscriptions.push(
          this.labelService
            .getLabel('allrightsreserved', 'general', true)
            .subscribe((l) => {
              this.lbl = l.labelText;
            })
        );
      }));
    this.subscriptions.push(
      this.labelService.refreshPageNameInCache('disclaimer').subscribe((e) => {
        this.subscriptions.push(
          this.labelService
            .getLabel('termsconditions', 'disclaimer', true)
            .subscribe((l) => {
              this.lblDisclaimer = l.labelText;
            })
        );
      }));

    this.subscriptions.push(
      this.loginService.getDisclaimer().subscribe((l) => {
        this.publicDisclaimer = l;
      })
    );

    this.subscriptions.push(
      this.authService
        .isLoggedIn()
        .pipe(distinctUntilChanged())
        .subscribe((isLoggedOn) => {
          this.loggedIn = isLoggedOn;
          if (isLoggedOn) {
            this.loginService.showDisclaimer().subscribe((e) => {
              this.showDisclaimer = e;
            });
          }
        })
    );
  }

  goToDisclaimer() {
    window.top.location.href =
      '/perfnav/logon/disclaimer.asp?show=noacceptance&dotnet=1';
  }

  ngOnDestroy() {
    for (const subscr of this.subscriptions) {
      subscr.unsubscribe();
    }
  }
}

